import moment from 'moment';

export function secondsToTime(seconds:number) {
	if(seconds != undefined && !isNaN(seconds)) {
		try {
			const s = new Date(1000 * seconds).toISOString();

			return s.substr(11, 3) != "00:" ? s.substr(11, 8) : s.substr(14, 5);
		} catch(error) {
			console.log(error);
		}
	} else {
		console.log("Incorrect variable passed to this.secondsToTime.");
	}

	return "";
}

export function intToTime(i: any) {
	return moment(i * 1000).utc().format('HH:mm:ss');
}

export function removeLoading(loading: any) {
	loading.prev().removeClass("hide");
	loading.next().removeClass("hide");
	loading.remove();
}